import { Injectable, Output, EventEmitter } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { Observer } from 'rxjs/Observer';
import { CustomStorage } from '../providers/Custom-storage.service';
import { CustomCookieService } from '../providers/mycookie.service';
// import { setInterval, setTimeout } from 'timers';


@Injectable()
export class SharedServiceService {

  @Output() filterStatus: EventEmitter<any> = new EventEmitter();
  @Output() showCategories: EventEmitter<any> = new EventEmitter();
  @Output() showProducts: EventEmitter<any> = new EventEmitter();
  @Output() showCategoriesList: EventEmitter<any> = new EventEmitter();
  @Output() showFooterSelected: EventEmitter<any> = new EventEmitter();
  @Output() filters: EventEmitter<any> = new EventEmitter();
  @Output() hideCategories: EventEmitter<any> = new EventEmitter();
  @Output() categoryDetails: EventEmitter<any> = new EventEmitter();
  @Output() hideLoading: EventEmitter<any> = new EventEmitter();
  @Output() backbutton: EventEmitter<any> = new EventEmitter();
  @Output() invoice: EventEmitter<any> = new EventEmitter();
  

  footerValue: string = 'account';
  productSearchFlag: boolean = false;
  hideCategoryFlag: boolean = false;
  backbuttonFlag : boolean = true;
  filterStatusFlag: boolean = false;
  locationObj: any;
  doNotAllowNegativeInvOrder: string = ""; 
  allowTopSellingItems: string = "";
  allowInspiredByPurchaseHistory: string = "";
  // myClass: boolean
  constructor(private cookieService: CustomCookieService, private localStorage: CustomStorage) { }

  changeFilter(flag) {
    this.filterStatusFlag = flag;
    this.filterStatus.emit(flag);
  }

  getFilterStatus() {
    return this.filterStatus;
  }

  getFilterStatusFlag() {
    return this.filterStatusFlag;
  }

  changeCategoriesStatus(flag) {
    this.showCategories.emit(flag);
  }

  getCategoriesStatus() {
    return this.showCategories;
  }

  changeProductsSearchStatus(productflag) {
    this.productSearchFlag = productflag;
    this.showProducts.emit(productflag);
  }

  getProductSearchFlag() {
    return this.productSearchFlag;
  }

  getProductStatus() {
    return this.showProducts;
  }


  changeBackbuttonStatus(buttonFlag){
    this.backbuttonFlag = buttonFlag;
    this.backbutton.emit(buttonFlag);
  }

  getBackbuttonFlag() {
    return this.backbuttonFlag;
  }

  getBackButton(){
    return this.backbutton;
  }

  changeCategoriesListStatus(flag) {
    this.showCategoriesList.emit(flag);
  }

  getCategoriesListStatus() {
    return this.showCategoriesList;
  }

  changeFooterSelected(flag) {
    this.footerValue = flag;
    this.showFooterSelected.emit(flag);
  }

  getFooterSelected() {
    return this.showFooterSelected;
  }

  getFooterValue() {
    return this.footerValue;
  }

  setFiltersData(filter) {
    this.filters.emit(filter);
  }

  getFilterValue() {
    return this.filters;
  }

  sethideCategoriesflag(hide) {
    this.hideCategoryFlag = hide;
    this.hideCategories.emit(hide);
  }

  getHideCategoriesFlag() {
    return this.hideCategoryFlag;
  }

  setCategoryDetails(name, count) {
    let category = {};
    category['name'] = name;
    category['count'] = count;

    this.categoryDetails.emit(category);
  }
  setLoadingFlag(load) {
    this.hideLoading.emit(load);
  }
  // setClass(myClass) {
  //   this.myClass = myClass;
  // }
  // getClass() {
  //   return this.myClass
  // }

  // wasClicked() {
  //   return Observable.create((observer: Observer<boolean>) => {
  //     // setTimeout(() => {
  //       observer.next(this.myClass)
  //       observer.complete();
  //     // }, 5000)

  //   })

  // }
  setInvoiceAmount(amt){
    this.invoice = amt
  }
  getInvoiceAmount(){
    return this.invoice;
  }

  removeAllData(){
    this.localStorage.emptyStorage();
    this.cookieService.removieCokkieData();
  }
 
  setDoNotAllowNegativeInvOrder(doNotAllow){
    this.doNotAllowNegativeInvOrder = doNotAllow;
  }

  getDoNotAllowNegativeInvOrder(){
    return this.doNotAllowNegativeInvOrder;
  }

  setAllowTopSellingItems(allowTopSelling){
    this.allowTopSellingItems = allowTopSelling;
  }

  getAllowTopSellingItems(){
    return this.allowTopSellingItems;
  }

  setAllowInspiredByPurchaseHistory(allowInspiredBy){
    this.allowInspiredByPurchaseHistory = allowInspiredBy;
  }

  getAllowInspiredByPurchaseHistory(){
    return this.allowInspiredByPurchaseHistory;
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/shared-service.service.ts